// @ts-strict-ignore
import {Scheduler, SchedulerEventLogEntry, SchedulerEventLogType} from "@models";
import {Component, Injector, OnInit, ViewChild} from "@angular/core";
import {SimSchedulerService, SimMaterialDialogService, SimUtilityExtendedService} from "@services";
import {TranslateService} from "@ngx-translate/core";
import {MatPaginator, MatPaginatorIntl, PageEvent} from "@angular/material/paginator";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";

export interface SCHEDULER_EVENT_DIALOG_INPUT extends MatDialogDataBaseInput {
	scheduler: Scheduler;
}

@Component({
	selector: "sim-scheduler-event-dialog",
	templateUrl: "./scheduler-event-dialog.component.html",
	styleUrls: ["./scheduler-event-dialog.component.scss"],
	standalone: false,
})
export class SchedulerEventDialogComponent
	extends BasicMaterialDialog<SchedulerEventDialogComponent, SCHEDULER_EVENT_DIALOG_INPUT>
	implements OnInit
{
	T = Translations;
	SchedulerEventLogType = SchedulerEventLogType;
	@ViewChild("paginator", {static: true}) paginator: MatPaginator;
	schedulerEventLogEntries: SchedulerEventLogEntry[];
	displayedColumns: string[] = ["createOn", "type", "name", "text"];
	totalRecords: number = 0;
	pageSize: number = 5;
	pageIndex: number = 0;
	selectedSchduler: any;

	constructor(
		private _simSchedulerService: SimSchedulerService,
		protected translate: TranslateService,
		private _simDialogService: SimMaterialDialogService,
		public _simUtilityServiceInjection: SimUtilityExtendedService,
		private paginatorIntl: MatPaginatorIntl,
		_injector: Injector,
	) {
		super(_injector);
	}

	ngOnInit() {
		this.getPagedData();
	}

	getPagedData() {
		this._simSchedulerService
			.getSchedulerEventLogEntriesByPaging(this.data.scheduler.id, this.pageIndex, this.pageSize)
			.then((getSchedulerEventLogEntriesResult) => {
				if (getSchedulerEventLogEntriesResult) {
					this.selectedSchduler = this.data.scheduler;
					this.schedulerEventLogEntries = getSchedulerEventLogEntriesResult.data;
					this.totalRecords = getSchedulerEventLogEntriesResult ? getSchedulerEventLogEntriesResult.totalCount : 0;
				}
			});
	}

	pageChangeEvent(event: PageEvent) {
		this.pageIndex = event.pageIndex;
		this.pageSize = event.pageSize;
		this.getPagedData();
	}

	clean() {
		const title = "Clean Logs";
		const description = "This will delete all event logs of this scheduler, only retaining the last 50 entries.";

		this._simDialogService
			.openDeleteDialog({
				deleteTitle: title,
				deleteText: description,
				deleteButtonText: this.translate.instant(this.T.BUTTON_OK),
				cancelText: this.translate.instant(this.T.BUTTON_CANCEL),
			})
			.then((data) => {
				if (data.action === "ok") {
					this._simSchedulerService.cleanSchedulerEventLogEntries(this.selectedSchduler).then((response) => {
						if (response) {
							this.getPagedData();
						} else {
						}
					});
				}
			});
	}

	refresh() {
		this.getPagedData();
	}
}
